"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asCurrencyWithAbbr = exports.asCurrency = void 0;
var _number = require("../type-checks/number");
var _string = require("../type-checks/string");
var asCurrency = exports.asCurrency = function asCurrency(input) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en-US";
  var numberFormatConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var returnValue = input;
  var formatter = new window.Intl.NumberFormat(locale, Object.assign({
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
  }, numberFormatConfig));
  if ((0, _number.isNumber)(returnValue) || (0, _string.isStringOfLength)(returnValue)) {
    returnValue.toString().replace(/[^\d.]/g, "").replace(/^(\d*(?:\.\d{0,2})?).*$/, function (a, b) {
      return b;
    });
    returnValue = formatter.format(returnValue);
  }
  return returnValue;
};
var asCurrencyWithAbbr = exports.asCurrencyWithAbbr = function asCurrencyWithAbbr(input) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$millionsAbbr = _ref.millionsAbbr,
    millionsAbbr = _ref$millionsAbbr === void 0 ? "m" : _ref$millionsAbbr,
    _ref$minTruncationVal = _ref.minTruncationValue,
    minTruncationValue = _ref$minTruncationVal === void 0 ? 100000 : _ref$minTruncationVal,
    _ref$precision = _ref.precision,
    precision = _ref$precision === void 0 ? 1 : _ref$precision,
    _ref$thousandsAbbr = _ref.thousandsAbbr,
    thousandsAbbr = _ref$thousandsAbbr === void 0 ? "k" : _ref$thousandsAbbr;
  // Let return value be input value;
  var returnValue = input;
  // If input is a number;
  if ((0, _number.isNumber)(input)) {
    // Let abbr be null;
    var abbrText = null;
    // If input exceeds truncation minimum and is over 1000;
    if (input >= minTruncationValue && input >= 1000) {
      // Set return value for thousands;
      returnValue = (input / 1000).toFixed(precision);
      // Set abbreviation text for thousands;
      abbrText = thousandsAbbr;
      // If input is over 1 million;
      if (input >= 1000000) {
        // Set return value for millions;
        returnValue = (input / 1000000).toFixed(precision);
        // Set abbreviation text for millions;
        abbrText = millionsAbbr;
      }
    }
    // Set return value;
    returnValue = asCurrency(returnValue, "en-US", {
      minimumFractionDigits: abbrText ? precision - 1 : 2
    });
    // If abbreviation text is defined;
    if ((0, _string.isStringOfLength)(abbrText)) {
      // Concatenate on return value;
      returnValue += abbrText;
    }
  }
  return returnValue;
};